import React from "react";
import { Box, Heading, Text, Badge, Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const CaseStudyCard = ({ study }) => {
  return (
    <Box
      borderWidth="1px"
      borderRadius="2xl"
      p={8}
      shadow="md"
      _hover={{ shadow: "xl", transform: "translateY(-5px)" }}
      transition="0.3s"
      height="100%"
      bg={"black"}
    >
      <Badge colorScheme="blue" fontSize="1.1rem" mb={2}>
        {study.category}
      </Badge>

      <Heading size="xl" mb={3}>
        {study.title}
      </Heading>

      <Text fontSize="1.8rem" color="black.900" mb={4}>
        {study.summary}
      </Text>

      <Link to={`/case-study/${study.id}`}>
        <Button border="2px solid white" bg="#EA0F0F" fontSize="1.5rem">
          View Case Study
        </Button>
      </Link>
    </Box>
  );
};

export default CaseStudyCard;